export interface ModelConfig {
  provider: string;
  model: string;
  temperature: number;
  max_tokens: number;
  input_variables: string[];
}

export type PromptTemplateCategory = "training" | "performance" | "motivation" | "discovery";
export type PromptTemplateAudience = "individual" | "team" | "manager";
export type PromptTemplateAbout = "individual" | "team";
export type PromptTemplatePrimaryFunction =
  | "onboarding"
  | "monthly 1:1 prep"
  | "90 day performance review"
  | "monday morning manager catch-up"
  | "friday team excellence"
  | "monthly team insights"
  | "customer insights"
  | "company insights";

export const PromptTemplateScope = {
  enlighten_me: "enlighten_me",
  coaching_hub: "coaching_hub"
} as const;

export type PromptTemplateScope = typeof PromptTemplateScope[keyof typeof PromptTemplateScope];

export interface PromptTemplateMetadata {
  category: PromptTemplateCategory;
  about: PromptTemplateAbout;
  audience: PromptTemplateAudience;
  primary_function: PromptTemplatePrimaryFunction;
  scope: PromptTemplateScope[];
  [key: string]: unknown;
}

export interface PromptTemplate {
  id: string;
  title: string;
  description: string;
  prompt: string;
  model_config: ModelConfig;
  metadata: PromptTemplateMetadata;
  enabled: boolean;
  created: string;
  modified: string;
}

export interface PromptTemplateResponse {
  data: PromptTemplate[] | null;
  error: Error | null;
}

export interface SinglePromptTemplateResponse {
  data: PromptTemplate | null;
  error: Error | null;
}

export interface PromptTemplateCreationParams {
  title: string;
  description: string;
  prompt: string;
  model_config: ModelConfig;
  metadata: PromptTemplateMetadata;
  enabled?: boolean;
}

export interface PromptTemplateUpdateParams {
  title?: string;
  description?: string;
  prompt?: string;
  model_config?: ModelConfig;
  metadata?: PromptTemplateMetadata;
  enabled?: boolean;
}
